import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import { FC } from 'react';
import { useTheme } from '@mui/material';
import { TCustomTheme } from '@mgm/common/theme';
import { useCustomTheme } from '@mgm/common/hooks/useCustomTheme';
import { BaseColorStepper } from '../../../../components/base/BStepper';
import { useAppSelector } from '../../../../hooks/useAppStore';
import { getActiveStep } from '../../../../store/commissions/selectors';

type TCreateCommissionPlan = {
  steps: Array<string>
};

const CreateCommissionPlan: FC<TCreateCommissionPlan> = ({ steps }) => {
  const activeStep = useAppSelector(getActiveStep);
  const theme = useTheme() as TCustomTheme;
  const { isMobile } = useCustomTheme(theme);

  return (
    <Box
      {...(isMobile && {
        width: '100%',
        pt: 2,
      })}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        border: '1px solid #F3E8FF',
        p: 4,
        mx: 3,
        borderRadius: 2,
      }}
    >
      <Stack
        sx={{
          width: '100%',
        }}
        spacing={4}
      >
        <BaseColorStepper activeStep={activeStep} steps={steps} />
      </Stack>
    </Box>
  );
};

export {
  CreateCommissionPlan,
};
